/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import MFRMHeader from '../../mfrm-components/mfrm-header/MFRMHeader';
import { IMfrmHeaderViewProps } from './mfrm-header';

export default (props: IMfrmHeaderViewProps) => {
    return (
        <div className='row'>
            <MFRMHeader {...props} />
        </div>
    );
};
